export enum SNSexType {
    Male = 'male',
    Female = 'female',
    Unknown = 'unknown'
}

export class SNSex {

    public type = SNSexType.Unknown;

    private sexMapping = {
        m: SNSexType.Male,
        male: SNSexType.Male,
        homme: SNSexType.Male,
        monsieur: SNSexType.Male,
        f: SNSexType.Female,
        female: SNSexType.Female,
        femme: SNSexType.Female,
        madame: SNSexType.Female,
    };
    private iconMapping = {
        male: ['fas', 'mars'],
        female: ['fas', 'venus'],
        unknown: ['fas', 'genderless']
    };

    private faIcon = ['fas', 'genderless'];

    constructor(sexString: string) {
        if (typeof sexString !== 'undefined' && sexString !== null) {
            if (typeof this.sexMapping[sexString.toLowerCase()] !== 'undefined') {
                this.type = this.sexMapping[sexString.toLowerCase()];
                this.faIcon = this.iconMapping[this.type];
            }
        }
    }

    get asFaIcon(): string[] {
        return this.faIcon;
    }

    public toString(): string {
        let stringRep = '';
        switch (this.type) {
            case SNSexType.Unknown:
                stringRep = 'Inconnu';
                break;
            case SNSexType.Male:
                stringRep = 'Homme';
                break;
            case SNSexType.Female:
                stringRep = 'Femme';
                break;
        }
        return stringRep;
    }
}
